/**
 * 爪爪驾校的图片素材（UI-ASSET-009 v1，r7k 2026-09-24 交付，见 docs/coordination/ui-assets/deliveries/UI-ASSET-009-v1.md；
 * 科目三小镇的屋顶、标志和首页横幅的 WebP 大图是 UI-ASSET-010 v1，r7k 2026-09-25 交付，见同目录 UI-ASSET-010-v1.md）。
 * 各处都从这里取网址，不在组件里另写路径。素材只是画面：玩家的宠物、驾照上的字、场地线和判定都由代码按真实数据画；
 * 图片加载失败时退回原来的代码画法。
 */
const ART = "/ui-assets/UI-ASSET-009/v1";
const TOWN = "/ui-assets/UI-ASSET-010/v1";

export const SCHOOL_ART = {
  coach: {
    /** 512×512 透明，头像在中间约 80% 的圆形安全区里 */
    portrait: `${ART}/coach-turtle-portrait.webp`,
    /** 640×640 透明，讲解的姿势 */
    explain: `${ART}/coach-turtle-explain.webp`,
    /** 640×640 透明，鼓掌的姿势 */
    cheer: `${ART}/coach-turtle-cheer.webp`,
    /** 720×720 透明，领证时举着一张空白卡 */
    ceremony: `${ART}/ceremony-coach.webp`,
  },
  /**
   * 驾校首页横幅：780×320，左边约 40% 是安静的天空和草地，标题用页面文字叠上去；
   * 2 倍屏的 1560×640 用 UI-ASSET-010 第 11 项（009 那张 1.98MB 的 PNG 机械转成的 WebP，268,666 B）。
   */
  hero: { src: `${ART}/school-hero.webp`, large: `${TOWN}/school-hero-large.webp`, width: 780, height: 320 },
  /** 驾照正反底图：856×540，四角透明，名字、号码、照片由代码叠上去 */
  license: { front: `${ART}/license-card-front-bg.webp`, back: `${ART}/license-card-back-bg.webp`, width: 856, height: 540 },
  /** 场地（画布用）：车朝右、车顶圆窗约在从车尾算起 40% 处；地面纹理 256×256 可无缝平铺 */
  field: {
    car: `${ART}/car-topdown.webp`,
    carLarge: `${ART}/car-topdown-large.webp`,
    treeA: `${ART}/field-tree-a.webp`,
    treeB: `${ART}/field-tree-b.webp`,
    bush: `${ART}/field-bush.webp`,
    cone: `${ART}/field-cone.webp`,
    flag: `${ART}/field-flag.webp`,
    grass: `${ART}/field-grass-tile.webp`,
    asphalt: `${ART}/field-asphalt-tile.webp`,
  },
  /**
   * 科目三小镇的建筑（画布用，按后端 courses.py 里建筑的 style 取）：
   * - 屋顶：256×256 四边无缝的纹理，平铺、钉在世界坐标上、裁进建筑多边形；
   * - 标志：128×128 透明底，只放在有名字的建筑中心（农场路口、邮局、小学、星球食堂）。同名 PNG 是原图，页面只用 WebP。
   */
  town: {
    roof: {
      house: `${TOWN}/roof-house.webp`,
      barn: `${TOWN}/roof-barn.webp`,
      farm: `${TOWN}/roof-farm.webp`,
      post: `${TOWN}/roof-post.webp`,
      school: `${TOWN}/roof-school.webp`,
      canteen: `${TOWN}/roof-canteen.webp`,
    },
    emblem: {
      farm: `${TOWN}/emblem-farm.webp`,
      post: `${TOWN}/emblem-post.webp`,
      school: `${TOWN}/emblem-school.webp`,
      canteen: `${TOWN}/emblem-canteen.webp`,
    },
  },
} as const;
